(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  if (root.reviewHubSchema) {
    root.reviewHubSchema.refresh();
    return;
  }
  root.reviewHubSchema = api.start(root.document, root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function copy(value) { return JSON.parse(JSON.stringify(value)); }
  function equal(a, b) { return JSON.stringify(a) === JSON.stringify(b); }
  function list(value) { return value == null ? [] : (Array.isArray(value) ? value : [value]); }
  function text(value) { return value == null ? '' : String(value).trim(); }
  function hasType(node, type) { return node && list(node['@type']).indexOf(type) !== -1; }
  function url(value, base) {
    try { return new URL(value, base); } catch (_) { return null; }
  }
  function canonical(value, base) {
    var parsed = url(value, base);
    return parsed && /^https?:$/.test(parsed.protocol) ? parsed.origin + parsed.pathname.replace(/\/$/, '') : '';
  }
  function currentProductPage(locationValue, canonicalValue) {
    var current = url(locationValue);
    var target = url(canonicalValue);
    if (!current || !target || current.origin !== target.origin) return false;
    if (canonical(current.href) === canonical(target.href)) return true;
    // Shopify also serves a product under a collection route with the same
    // canonical product URL. Only that known alternate route is accepted.
    var currentPath = current.pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '');
    return currentPath === target.pathname;
  }
  function walk(value, fn, path) {
    path = path || [];
    if (!value || typeof value !== 'object') return;
    if (!Array.isArray(value)) fn(value, path);
    Object.keys(value).forEach(function (key) { walk(value[key], fn, path.concat(key)); });
  }
  function validAggregate(value) {
    if (!value || !Number.isInteger(value.reviewCount) || value.reviewCount < 1) return null;
    var rating = Number(value.ratingValue);
    if (!Number.isFinite(rating) || rating < 1 || rating > 5) return null;
    return { '@type': 'AggregateRating', ratingValue: rating, reviewCount: value.reviewCount, bestRating: 5, worstRating: 1 };
  }
  function hasReviewAggregate(node) {
    var aggregate = node.aggregateRating;
    if (!hasType(aggregate, 'AggregateRating')) return false;
    function numeric(value) {
      return (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) ? Number(value) : NaN;
    }
    var count = numeric(aggregate.reviewCount == null ? aggregate.ratingCount : aggregate.reviewCount);
    var rating = numeric(aggregate.ratingValue);
    var best = aggregate.bestRating == null ? 5 : numeric(aggregate.bestRating);
    var worst = aggregate.worstRating == null ? 1 : numeric(aggregate.worstRating);
    return Number.isInteger(count) && count > 0 && Number.isFinite(rating)
      && Number.isFinite(best) && Number.isFinite(worst) && best > worst && rating >= worst && rating <= best;
  }
  function pageMembers(value, productId) {
    if (!Array.isArray(value)) return [];
    return value.filter(function (member) {
      return member && text(member.productId) === productId && text(member.variantId) && text(member.sku);
    }).map(function (member) {
      return { productId: productId, variantId: text(member.variantId), sku: text(member.sku) };
    }).sort(function (left, right) { return JSON.stringify(left).localeCompare(JSON.stringify(right)); });
  }
  function combinePayloads(payloads, page) {
    var pageUrl = canonical(page.url, page.locationUrl);
    if (page.type !== 'product' || !text(page.productId) || !pageUrl || !currentProductPage(page.locationUrl, pageUrl)) return null;
    if (!/\/products\/[^/]+$/.test(url(pageUrl).pathname)) return null;
    var result = null;
    var conflict = false;
    payloads.forEach(function (payload) {
      if (!payload || payload.version !== 1 || !payload.page || !payload.family) return;
      if (payload.page.type !== 'product' || text(payload.page.productId) !== text(page.productId) || canonical(payload.page.url, pageUrl) !== pageUrl) return;
      var family = payload.family;
      var members = pageMembers(payload.page.members, text(page.productId));
      var familyUrl = url(family.id, pageUrl);
      if (!text(family.key) || !text(family.name) || !text(family.productGroupId) || ['native', 'multipage'].indexOf(family.mode) === -1) return;
      if (!familyUrl || familyUrl.origin !== url(pageUrl).origin || !familyUrl.hash) return;
      if (result && (result.family.key !== family.key || result.family.id !== family.id || result.family.mode !== family.mode || text(result.family.productGroupId) !== text(family.productGroupId) || !equal(result.page.members, members))) {
        conflict = true;
        return;
      }
      if (!result) result = { page: { type: 'product', productId: text(page.productId), url: pageUrl, members: members }, family: copy(family), aggregate: null, reviews: [] };
      result.aggregate = validAggregate(payload.aggregate);
      result.reviews = result.reviews.concat(Array.isArray(payload.reviews) ? payload.reviews : []);
    });
    return conflict ? null : result;
  }
  function reviewValue(entry, pageUrl) {
    if (!entry || !text(entry.id) || !entry.review || !hasType(entry.review, 'Review')) return null;
    var review = entry.review;
    var rating = review.reviewRating && Number(review.reviewRating.ratingValue);
    if (!review.author || !text(review.author.name) || !Number.isFinite(rating) || rating < 1 || rating > 5) return null;
    var value = copy(review);
    value['@id'] = pageUrl + '#reviewhub-review-' + encodeURIComponent(text(entry.id));
    // The enclosing native product is the subject; never carry nested products.
    delete value.itemReviewed;
    delete value['@context'];
    return value;
  }
  function nativeIdentity(node, pageUrl, fragment) {
    var identity = url(node['@id'], pageUrl);
    return identity && canonical(identity.href) === pageUrl && identity.hash === fragment;
  }
  function variantMatches(node, entry, pageUrl) {
    if (!hasType(node, 'Product') || !text(entry.sku) || text(node.sku) !== text(entry.sku)) return false;
    var identity = url(node['@id'], pageUrl);
    if (!identity || canonical(identity.href) !== pageUrl) return false;
    if (!text(entry.variantId)) return true;
    if (identity.hash === '#variant-' + text(entry.variantId)) return true;
    return list(node.offers).some(function (offer) {
      var offerUrl = offer && url(offer.url, pageUrl);
      return offerUrl && canonical(offerUrl.href) === pageUrl && offerUrl.searchParams.get('variant') === text(entry.variantId);
    });
  }
  function matchesPageMember(node, context) {
    var matching = context.page.members.filter(function (member) { return member.sku === text(node.sku); });
    if (matching.length !== 1) return false;
    var member = matching[0];
    var identities = [];
    if (node.url) identities.push(node.url);
    walk(node.offers, function (offer) { if (offer.url) identities.push(offer.url); });
    return identities.every(function (value) {
      var identity = url(value, context.page.url);
      if (!identity) return false;
      var variantIds = identity.searchParams.getAll('variant');
      return variantIds.every(function (id) { return id === member.variantId; });
    });
  }
  function compatibleFamily(node, context) {
    if (node.isVariantOf != null) {
      var references = list(node.isVariantOf);
      if (references.length !== 1 || !references[0] || typeof references[0] !== 'object') return false;
      var existing = url(references[0]['@id'], context.page.url);
      var intended = url(context.family.id, context.page.url);
      if (!existing || !intended || existing.href !== intended.href) return false;
    }
    return node.inProductGroupWithID == null || text(node.inProductGroupWithID) === text(context.family.productGroupId);
  }

  // Work on copies and return a reversible ledger, so repeated loads and native
  // theme rerenders can replace our contribution without accumulating reviews.
  function enrichGraph(documents, payloads, page) {
    var output = documents.map(copy);
    var result = combinePayloads(payloads, page);
    var edits = output.map(function () { return []; });
    var group = null;
    if (!result) return { documents: output, edits: edits, group: null, result: null };
    var candidates = [];
    output.forEach(function (document, index) {
      walk(document, function (node, path) {
        if (!nativeIdentity(node, result.page.url, '#product')) return;
        if (result.family.mode === 'native' && hasType(node, 'ProductGroup') && text(node.productGroupID) === text(result.family.productGroupId)) candidates.push({ node: node, path: path, index: index });
        if (result.family.mode === 'multipage' && hasType(node, 'Product') && matchesPageMember(node, result) && compatibleFamily(node, result)) candidates.push({ node: node, path: path, index: index });
      });
    });
    if (candidates.length !== 1) return { documents: output, edits: edits, group: null, result: null };
    var target = candidates[0];
    function set(node, path, key, value, addedIds) {
      if (equal(node[key], value)) return;
      edits[target.index].push({ path: path.concat(key), present: Object.prototype.hasOwnProperty.call(node, key), before: node[key] === undefined ? null : copy(node[key]), after: copy(value), addedIds: addedIds || [] });
      node[key] = value;
    }
    if (result.family.mode === 'multipage') {
      // Reuse the native Product and its offers; the family has no canonical URL.
      group = { '@context': 'https://schema.org', '@type': 'ProductGroup', '@id': result.family.id, productGroupID: text(result.family.productGroupId), name: result.family.name, variesBy: list(result.family.variesBy) };
      if (text(result.family.brand)) group.brand = { '@type': 'Brand', name: result.family.brand };
      if (result.aggregate && page.aggregateVisible !== false) group.aggregateRating = copy(result.aggregate);
      if (target.node.isVariantOf == null) set(target.node, target.path, 'isVariantOf', { '@id': result.family.id });
      if (target.node.inProductGroupWithID == null) set(target.node, target.path, 'inProductGroupWithID', text(result.family.productGroupId));
    } else if (result.aggregate && page.aggregateVisible !== false) {
      set(target.node, target.path, 'aggregateRating', copy(result.aggregate));
    }
    var additions = [];
    result.reviews.forEach(function (entry) {
      if (text(entry.productId) !== result.page.productId) return;
      var value = reviewValue(entry, result.page.url);
      if (!value) return;
      var reviewTargets = [];
      if (entry.scope === 'product') reviewTargets = [{ node: target.node, path: target.path }];
      if (entry.scope === 'sku') {
        if (result.family.mode === 'native') {
          walk(target.node.hasVariant, function (node, path) {
            if (variantMatches(node, entry, result.page.url)) reviewTargets.push({ node: node, path: target.path.concat('hasVariant').concat(path) });
          });
        } else if (text(entry.sku) === text(target.node.sku) && result.page.members.some(function (member) {
          return member.sku === text(entry.sku) && (!text(entry.variantId) || member.variantId === text(entry.variantId));
        })) reviewTargets = [{ node: target.node, path: target.path }];
      }
      // Ambiguous duplicate SKU nodes do not establish an exact variant.
      if (reviewTargets.length !== 1) return;
      var match = reviewTargets[0];
      var existing = list(match.node.review);
      if (existing.some(function (review) { return review && review['@id'] === value['@id']; })) return;
      var key = JSON.stringify(match.path);
      var addition = additions.find(function (item) { return item.key === key; });
      // Multiple reviews require an aggregate on this exact subject. The family
      // aggregate is not a variant rating. Keep the first visible review only;
      // existing native reviews consume that slot and are never overwritten.
      if (!hasReviewAggregate(match.node) && (addition ? addition.values : existing).length >= 1) return;
      if (!addition) {
        addition = { key: key, node: match.node, path: match.path, values: existing.slice(), ids: [] };
        additions.push(addition);
      }
      if (addition.ids.indexOf(value['@id']) === -1) { addition.values.push(value); addition.ids.push(value['@id']); }
    });
    additions.forEach(function (addition) { set(addition.node, addition.path, 'review', addition.values, addition.ids); });
    return { documents: output, edits: edits, group: group, result: result };
  }

  function restoreOwned(document, edits) {
    var restored = copy(document);
    (edits || []).slice().reverse().forEach(function (edit) {
      var parent = restored;
      for (var i = 0; i < edit.path.length - 1 && parent; i++) parent = parent[edit.path[i]];
      if (!parent || typeof parent !== 'object') return;
      var key = edit.path[edit.path.length - 1];
      if (equal(parent[key], edit.after)) {
        if (edit.present) parent[key] = copy(edit.before); else delete parent[key];
      } else if (key === 'review' && edit.addedIds.length) {
        var remaining = list(parent[key]).filter(function (review) { return !review || edit.addedIds.indexOf(review['@id']) === -1; });
        if (remaining.length) parent[key] = remaining; else delete parent[key];
      }
    });
    return restored;
  }

  function start(document, window) {
    var owned = new WeakMap();
    var uiOwned = new Map();
    var timer = null;
    var running = false;
    var selector = 'script[type="application/json"][data-review-hub-schema]';
    function parse(script) { try { return JSON.parse(script.textContent); } catch (_) { return null; } }
    function pageContext() {
      var link = document.querySelector('link[rel="canonical"]');
      var pageUrl = canonical(link && link.getAttribute('href'), window.location.href);
      var loaders = Array.prototype.slice.call(document.querySelectorAll('script[data-review-hub-schema-loader]'));
      var matchingLoaders = loaders.filter(function (item) { return item.getAttribute('data-page-type') === 'product' && canonical(item.getAttribute('data-page-url'), window.location.href) === pageUrl; });
      var loader = matchingLoaders[0];
      if (loader && matchingLoaders.some(function (item) { return item.getAttribute('data-page-product-id') !== loader.getAttribute('data-page-product-id'); })) loader = null;
      var badges = Array.prototype.slice.call(document.querySelectorAll('[data-review-hub-badge]'));
      return { type: loader ? loader.getAttribute('data-page-type') : '', productId: loader ? loader.getAttribute('data-page-product-id') : '', url: pageUrl, locationUrl: window.location.href, locale: text(document.documentElement.lang).split('-')[0] || 'de', aggregateVisible: badges.some(function (badge) {
        if (badge.hidden || !badge.querySelector('.rh-count')) return false;
        if (badge.getClientRects && badge.getClientRects().length === 0) return false;
        return !window.getComputedStyle || window.getComputedStyle(badge).visibility !== 'hidden';
      }) };
    }
    function setUi(node, value) {
      if (!node) return;
      var state = uiOwned.get(node);
      if (!state) { state = { before: node.textContent, beforeHtml: node.innerHTML, after: null, ariaLabel: node.getAttribute('aria-label') }; uiOwned.set(node, state); }
      if (node.textContent !== value) node.textContent = value;
      state.after = value;
    }
    function restoreUi() {
      uiOwned.forEach(function (state, node) {
        if (node.textContent === state.after) {
          if (typeof state.beforeHtml === 'string') node.innerHTML = state.beforeHtml; else node.textContent = state.before;
        }
        if (state.ariaLabel === null) node.removeAttribute('aria-label'); else node.setAttribute('aria-label', state.ariaLabel);
      });
      uiOwned.clear();
    }
    function updateUi(result, page) {
      if (!result || !result.aggregate) { restoreUi(); return; }
      var locale = ['de', 'en', 'fr', 'it'].indexOf(page.locale) !== -1 ? page.locale : 'de';
      var familyName = result.family.labels && result.family.labels[locale] || result.family.name;
      var words = { de: ['Bewertungen', 'Bewertungen für'], en: ['reviews', 'Reviews for'], fr: ['avis', 'Avis sur'], it: ['recensioni', 'Recensioni per'] }[locale];
      var rating = result.aggregate.ratingValue;
      var formattedRating = rating.toLocaleString(locale, { maximumFractionDigits: 2 });
      var stars = '';
      for (var i = 1; i <= 5; i++) stars += i <= Math.round(rating) ? '★' : '☆';
      document.querySelectorAll('[data-review-hub-badge]').forEach(function (badge) {
        setUi(badge.querySelector('.rh-stars'), stars);
        var container = badge.closest('[data-review-hub-badge-container], [data-review-hub-app-badge]');
        var note = container && container.querySelector('.fa-seo-review-note');
        var count = result.aggregate.reviewCount + ' ' + words[0];
        setUi(badge.querySelector('.rh-count'), note ? count : formattedRating + ' / 5 · ' + count + ' · ' + familyName);
        if (note) setUi(note, formattedRating + ' / 5 · ' + words[1] + ' ' + familyName + '.');
        var starNode = badge.querySelector('.rh-stars');
        if (starNode) starNode.setAttribute('aria-label', String(rating) + ' / 5');
      });
    }
    function refresh() {
      if (running) return;
      running = true;
      try {
        var page = pageContext();
        var payloads = Array.prototype.slice.call(document.querySelectorAll(selector)).map(parse).filter(Boolean);
        var scripts = [];
        var documents = [];
        document.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
          if (script.hasAttribute('data-review-hub-family-graph')) return;
          var value = parse(script);
          if (!value) return;
          scripts.push(script);
          documents.push(restoreOwned(value, owned.get(script)));
        });
        var enriched = enrichGraph(documents, payloads, page);
        scripts.forEach(function (script, index) {
          if (!equal(parse(script), enriched.documents[index])) script.textContent = JSON.stringify(enriched.documents[index]).replace(/</g, '\\u003c');
          owned.set(script, enriched.edits[index]);
        });
        var familyScript = document.querySelector('script[data-review-hub-family-graph]');
        if (enriched.group) {
          if (!familyScript) { familyScript = document.createElement('script'); familyScript.type = 'application/ld+json'; familyScript.setAttribute('data-review-hub-family-graph', ''); document.head.appendChild(familyScript); }
          if (!equal(parse(familyScript), enriched.group)) familyScript.textContent = JSON.stringify(enriched.group).replace(/</g, '\\u003c');
        } else if (familyScript) familyScript.remove();
        updateUi(enriched.result, page);
      } finally { running = false; }
    }
    function schedule() {
      if (timer !== null) return;
      timer = window.setTimeout(function () { timer = null; refresh(); }, 0);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true }); else schedule();
    var observer = new window.MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('popstate', schedule);
    window.addEventListener('resize', schedule);
    return { refresh: schedule, disconnect: function () { observer.disconnect(); }, run: refresh };
  }
  return { combinePayloads: combinePayloads, enrichGraph: enrichGraph, restoreOwned: restoreOwned, start: start };
});
